import Cte from "@/domain/notas/cte/Cte.js";
import Table from "./Table";
export default class TableCte extends Table {
    constructor() {
        super();
    }


    getHeaders() {
        var headers = [
            { text: "Ações", sortable: false, value: "acoes", show: true, pesq: false, enable: false},
            { text: "Data de Emissão", value: "emissao", show: true, width: "500px", pesq: false, enable: true},
            { text: "Número", value: "numero", width: "500px", show: true, pesq: true, enable: true},

            { text: "Remetente", value: "remetNome", width: "300000px", show: true, pesq: false, enable: true},
            { text: "Valor da CT-e", value: "valor", width: "500px", show: true, pesq: false, enable: true},
            { text: "IE do Remetente", value: "remetIe", width: "500px", show: true, pesq: false, enable: true},
            { text: "CNPJ/CPF do Remetente", value: "remetCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "Chave de Acesso", value: "chave", width: "500px", show: true, pesq: true, enable: true},
            { text: "Destinatário", value: "destNome", width: "500px", show: true, pesq: false, enable: true},
            { text: "CNPJ/CPF do Destinatário", value: "destCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "IE do Destinatário", value: "destIe", width: "500px", show: true, pesq: false, enable: true},
            { text: "Origem", value: "origem", width: "500px", show: true, pesq: false, enable: true},
            { text: "Status", value: "status", width: "500px", show: true, pesq: false, enable: true},
            { text: "Tipo", value: "tipo", width: "500px", show: true, pesq: false, enable: true},

            { text: "CNPJ/CPF do Tomador", value: "tomadorCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "Tomador", value: "tomadorNome", width: "500px", show: true, pesq: false, enable: true},
            { text: "IE do Tomador", value: "tomadorIe", width: "500px", show: true, pesq: false, enable: true},

            { text: "CNPJ/CPF do Emitente", value: "emitCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "Emitente", value: "emitNome", width: "500px", show: true, pesq: false, enable: true},
            { text: "IE do Emitente", value: "emitIe", width: "500px", show: true, pesq: false, enable: true},

            { text: "CNPJ/CPF do Expedidor", value: "expedidorCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "Expedidor", value: "expedidorNome", width: "500px", show: true, pesq: false, enable: true},
            { text: "IE do Expedidor", value: "expedidorIe", width: "500px", show: true, pesq: false, enable: true},

            { text: "CNPJ/CPF do Recebedor", value: "recebCnpj", width: "500px", show: true, pesq: true, enable: true},
            { text: "Recebedor", value: "recebNome", width: "500px", show: true, pesq: false, enable: true},
            { text: "IE do Recebedor", value: "recebIe", width: "500px", show: true, pesq: false, enable: true},

            { text: "Data de Importação", value: "dtImportacao", width: "500px", show: true, pesq: false, enable: true},
            { text: "Vínculo", value: "vinculo", width: "500px", show: true, pesq: false, enable: true},
            { text: "Status ERP", value: "statusErp", width: "500px", show: true, pesq: false, enable: true},

            { text: "Danfe", value: "danfe", width: "500px", show: false, pesq: false, enable: false},
            { text: "_id", value: "_id", width: "500px", show: false, pesq: false, enable: false},
            { text: "id_empresa", value: "empresa", width: "500px", show: false, pesq: false, enable: false},
            { text: "nfe", value: "nfe", width: "500px", show: false, pesq: false, enable: false},
            { text: "xml", value: "xml", width: "500px", show: false, pesq: false, enable: false},

            { text: "Manifestacao", value: "manifestacao", show: true, pesq: false, enable: true },
            { text: "Modal", value: "modal", show: true, pesq: true, enable: true },
            { text: "Sistema", value: "verProc", show: true, pesq: true, enable: true },
            { text: "Data ERP", value: "data_erp", show: true, pesq: true, enable: true },
            { text: "Departamento", value: "departamento", show: true, pesq: true, enable: true },
            { text: "log integração ERP", value: "log_statusErp", show: false, pesq: false,enable:true},
            { text: "Id Fluig", value: "id_fluig", show: true, pesq: true,enable:true},
            { text: "log integração ERP Dois", value: "log_statusErpDois", show: false, pesq: false,enable:true},
            { text: "StatusErp Dois", value: "statusErpDois", show: true, pesq: false,enable:true}


        ]
        return headers
    }

    setNota(arrayNotas, notas) {
        let newArray = arrayNotas;
        this.loading = false;
        for (var i = 0; i < notas.length; i++) {
            newArray.push(
                new Cte(
                    notas[i].chave,
                    notas[i].destCnpjCpf,
                    notas[i].destIe,
                    notas[i].destNome,
                    notas[i].emissao,
                    notas[i].dtImportacao,
                    notas[i].emitCnpjCpf,
                    notas[i].emitIe,
                    notas[i].emitNome,
                    notas[i].empresa,
                    notas[i].expedidorCnpjCpf,
                    notas[i].expedidorIe,
                    notas[i].expedidorNome,
                    notas[i].nfe,
                    notas[i].numero,
                    notas[i].origem,
                    notas[i].recebCnpjCpf,
                    notas[i].recebIe,
                    notas[i].recebNome,
                    notas[i].remetCnpjCpf,
                    notas[i].remetIe,
                    notas[i].remetNome,
                    notas[i].status,
                    notas[i].tipo,
                    notas[i].tomadorCnpjCpf,
                    notas[i].tomadorIe,
                    notas[i].tomadorNome,
                    notas[i]['statusErp'],
                    notas[i].valor,
                    notas[i]._id,
                    notas[i].customValues,
                    notas[i].danfe,
                    notas[i].manifestacao,
                    notas[i].modal,
                    notas[i].verProc,
                    notas[i].data_erp,
                    notas[i].departamento,
                    notas[i].log_statusErp,
                    notas[i].id_fluig,
                    notas[i].log_statusErpDois,
                    notas[i].statusErpDois
                )
            );
            

            this.pagination.sortBy = 'emissao';
            this.pagination.descending = true;
        }
        if(arrayNotas.length > 0) {
            arrayNotas = [ ...arrayNotas, ...newArray ];
            return arrayNotas;
        }else {
            return newArray;
        }
    }
}





// WEBPACK FOOTER //
// ./src/domain/dataTable/TableCte.js